const mediaItems = [
  {
    id: 1,
    title: '繁花',
    subtitle: '王家卫导演 胡歌主演 · 沪上风云',
    category: '热播剧集',
    rating: '9.4',
    badge: '更新至 30 集',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20of%20Shanghai%20in%201990s%2C%20neon%20lights%2C%20nostalgic%20street%20with%20warm%20amber%20glow%2C%20dramatic%20lighting%2C%20film%20noir%20aesthetic%2C%20rich%20contrast%2C%20cinematic%20composition%2C%20no%20people%2C%20artistic%20style&width=600&height=900&seq=media-01&orientation=portrait',
  },
  {
    id: 2,
    title: '流浪地球3',
    subtitle: '郭帆导演 · 中国科幻巨制',
    category: '热门电影',
    rating: '8.7',
    badge: 'HD 高清',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20futuristic%20space%20scene%20with%20a%20massive%20planet%20and%20spaceship%2C%20dramatic%20cosmic%20lighting%2C%20sci-fi%20atmosphere%2C%20deep%20blue%20and%20orange%20contrast%2C%20cinematic%20composition%2C%20no%20text%2C%20epic%20scale&width=600&height=900&seq=media-02&orientation=portrait',
  },
  {
    id: 3,
    title: '庆余年2',
    subtitle: '张若昀领衔 · 古装权谋大作',
    category: '热播剧集',
    rating: '9.1',
    badge: '全集完结',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20warm%20candlelight%2C%20traditional%20architecture%2C%20dramatic%20shadows%2C%20cinematic%20lighting%2C%20historical%20atmosphere%2C%20rich%20amber%20tones%2C%20no%20people%2C%20artistic%20style&width=600&height=900&seq=media-03&orientation=portrait',
  },
  {
    id: 4,
    title: '封神第二部',
    subtitle: '乌尔善导演 · 神话史诗巨作',
    category: '热门电影',
    rating: '8.9',
    badge: '4K 修复',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20landscape%20with%20dramatic%20skies%2C%20epic%20scale%2C%20warm%20golden%20and%20crimson%20lighting%2C%20traditional%20Chinese%20elements%2C%20cinematic%20composition%2C%20no%20people%2C%20artistic%20style&width=600&height=900&seq=media-04&orientation=portrait',
  },
  {
    id: 5,
    title: '三体·动画版',
    subtitle: '刘慈欣原著 · 科幻动画巨制',
    category: '人气动漫',
    rating: '8.5',
    badge: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20laboratory%20with%20holographic%20displays%2C%20dramatic%20blue%20and%20warm%20lighting%2C%20high-tech%20atmosphere%2C%20cinematic%20composition%2C%20clean%20aesthetic%2C%20no%20people%2C%20artistic%20style&width=600&height=900&seq=media-05&orientation=portrait',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              影视精选
            </h2>
            <p className="text-sm text-foreground-500 mt-1">热门影视一网打尽，高清免费随心看</p>
          </div>
          <a
            href="#carousel"
            onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            更多专题 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[2/3] w-full overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent"></div>

                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-white text-[10px] font-medium whitespace-nowrap">
                    {item.category}
                  </span>
                </div>

                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded-md bg-black/50 backdrop-blur-sm text-accent-400 text-[10px] font-bold whitespace-nowrap">
                    {item.rating}
                  </span>
                </div>

                <div className="absolute bottom-2 left-2 right-2">
                  <span className="text-[10px] text-white/70 whitespace-nowrap">{item.badge}</span>
                </div>

                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-white text-2xl"></i>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}